// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconCell_wrapper__1TVsh","link":"IconCell_link__G9PgZ"};